@if (!isMobile) {
    <div class="inventory-bins-container">
        <div class="inventory-header" rtlDiv>
            {{'SIDEBAR.INVENTORY' | translate }}
        </div>
    
        <div class="inventory-body">
            <div class="search-input-container-wrapper" rtlDiv>
                <div class='search-input-container' rtlDiv>
                    <img class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />
                    <input class='search-input' type="text" (input)="applyFilter($event.target)" placeholder="{{'OTHER.SEARCH' | translate }}" id="bin-search-input-modal">
                </div>
            </div>
            <div class="dflex-table" rtlDiv>
                <div class="width100">
                    <table class="table-modal" mat-table #table [dataSource]="dataSource" matSort
                        matSortStart="asc" matSortActive="bin_name" matSortDisableClear
                        (matSortChange)="sortData($event)" matSortDirection="desc">
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                            </th>
                            <td mat-cell *matCellDef="let row" class="list-checkbox" rtlDiv>
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th [hidden]="!binNameCol && usageType == 2" mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="th-title space"> 
                                {{ 'LIST_COLUMNS.NAME' | translate }} 
                            </th>
                            <td [hidden]="!binNameCol && usageType == 2" mat-cell *matCellDef="let element" class="td-value space" 
                            [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                <div class="flex-th-value">
                                    <span title="{{element ? element.bin_name : ''}}">{{element ? element.bin_name : ''}}</span>
                                    @if (element.number_of_bins_in_cluster > 1 && element.chosenCluster) {
                                        <button class="tooltip-btn" type="button">
                                            <img src="assets/images/binInfoPage/clusterIndication.svg" alt="" />
                                        </button>
                                    }
                                    @if (element.isOpenTicket) {
                                    <div>
                                        <img src="assets/images/binInfoPage/open_ticket_indication.svg" alt="" />
                                    </div>
                                    }
                                </div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="site_name">
                            <th [hidden]="!binSiteCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="site_name" class="th-title space"> {{ 'TRUCK_MAP.SITE' |
                                translate }} </th>
                            <td [hidden]="!binSiteCol" mat-cell *matCellDef="let element" class="td-value space"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> {{element ?
                                element.site_name: ''}} </td>
                        </ng-container>
    
                        <ng-container matColumnDef="id">
                            <th [hidden]="!binIdCol" mat-header-cell *matHeaderCellDef mat-sort-header="bin_id" class="th-title space"> 
                                {{ 'LIST_COLUMNS.ID' | translate }} 
                            </th>
                            <td [hidden]="!binIdCol" mat-cell *matCellDef="let element" class="td-value space"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.bin_id: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="device_id">
                            <th [hidden]="!binDeviceIdCol" mat-header-cell *matHeaderCellDef mat-sort-header="device_id" class="th-title space"> 
                                {{'SITE_MANAGMENT.DEVICE_ID' | translate }} 
                            </th>
                            <td [hidden]="!binDeviceIdCol" mat-cell *matCellDef="let element" class="td-value space"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.device_id: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="type">
                            <th [hidden]="!binTypeCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="bin_type" class="th-title space"> {{ usageType == 1 ?
                                (translationsObj ? translationsObj.LIST_COLUMNS.BIN_TYPE : '') :
                                (translationsObj ? translationsObj.LIST_COLUMNS.TANK_TYPE : '')}} </th>
                            <td [hidden]="!binTypeCol" mat-cell *matCellDef="let element" class="td-value space"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.bin_type: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="address" class="space th-title"> 
                                {{ 'LIST_COLUMNS.ADDRESS'| translate }} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="space td-value" [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.address: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="neighborhood">
                            <th [hidden]="!neighborhood || usageType == 2" mat-header-cell *matHeaderCellDef mat-sort-header="neighborhood" class="space th-title">
                                {{'LIST_COLUMNS.NEIGHBORHOOD' | translate }}
                            </th>
                            <td [hidden]="!neighborhood || usageType == 2" class="space td-value" mat-cell
                                *matCellDef="let element" [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.neighborhood: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="cluster_id">
                            <th [hidden]="usageType == 1" mat-header-cell *matHeaderCellDef mat-sort-header="cluster_id" class="space th-title"> 
                                {{'LIST_COLUMNS.DESCRIPTION' | translate }} 
                            </th>
                            <td [hidden]="usageType == 1" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.description: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="description">
                            <th [hidden]="usageType == 2" mat-header-cell *matHeaderCellDef mat-sort-header="description" class="space th-title"> 
                                {{'LIST_COLUMNS.DESCRIPTION' | translate}} 
                            </th>
                            <td [hidden]="usageType == 2" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.description: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="size">
                            <th [hidden]="usageType == 1" mat-header-cell *matHeaderCellDef mat-sort-header="size" class="space th-title">
                                {{'LIST_COLUMNS.QUARTER_ACRE' | translate}}
                            </th>
                            <td [hidden]="usageType == 1" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}"> 
                                {{element ? element.size: ''}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="installation_Date">
                            <th [hidden]="!binInstallDateCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="installation_DateTime_value" class="space th-title"> 
                                {{'LIST_COLUMNS.INSTALLATION_DATE' | translate }} 
                            </th>
                            <td [hidden]="!binInstallDateCol" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                <span>{{element ? element.bin_installation_date : ''}}</span>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="last_collection">
                            <th [hidden]="usageType != 1" mat-header-cell *matHeaderCellDef mat-sort-header="last_collection" class="space th-title"> 
                                {{'LIST_COLUMNS.LAST_COLLECTION' | translate }} 
                            </th>
                            <td [hidden]="usageType != 1" mat-cell *matCellDef="let element" class="space td-value">
                                @if (element.collection_mode != 1) {
                                    <span title="{{element.last_collection}}">{{element.calcDiff_lastCollection}}</span>
                                }
                                @if (element.collection_mode == 1) {
                                    <hr class="dashed-hr">
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="last_refill">
                            <th [hidden]="usageType == 1" mat-header-cell *matHeaderCellDef mat-sort-header="last_refill" class="space th-title"> 
                                {{'LIST_COLUMNS.LAST_REFILL' | translate }} 
                            </th>
                            <td [hidden]="usageType == 1" mat-cell *matCellDef="let element" class="space td-value">
                                @if (element.collection_mode != 1) {
                                    <span>{{element.calcDiff_lastRefill}}</span>
                                }
                                @if (element.collection_mode == 1) {
                                    <hr class="dashed-hr">
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="last_update">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="last_update" class="space th-title"> 
                                {{'LIST_COLUMNS.LAST_UPDATE' | translate }} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="space td-value">
                                @if (element.collection_mode != 1) {
                                    <span title="{{element.last_update}}">{{element.calcDiff_lastUpdate}}</span>
                                }
                                @if (element.collection_mode == 1) {
                                    <hr class="dashed-hr">
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="status" class="space th-title">
                                {{'LIST_COLUMNS.STATUS' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element" class="space">
                                @if (element.collection_mode != 1) {
                                    <div class="progress-flex">
                                        <div class="table-status-progress-bar-wrapper progress">
                                            <div class="table-status-progress-line progress-bar" [ngStyle]="getProgressBarStyleInternal(element)"></div>
                                        </div>
                                        <div class='table-status-progress-bar-title' rtlDiv>{{element ? element.bin_capacity_to_display: ''}}</div>
                                    </div>
                                }
                                @if (element.collection_mode == 1) {
                                    <hr class="dashed-hr">
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="avg_rate">
                            <th [hidden]="!binAvgRateCol" mat-header-cell *matHeaderCellDef mat-sort-header="avg_rate" class="space th-title">
                                @if (usageType == 1) {
                                    <span>{{'LIVE_INFO.EMPTY_RATE' | translate}}</span>
                                }
                            </th>
                            <td [hidden]="!binAvgRateCol" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                @if (usageType == 1) {
                                    <span>{{element.avg_rate | number:'1.0-2'}}{{element.avg_rate != null ? '%' : ''}} </span>
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="avg_usage_rate">
                            <th [hidden]="!binAvgUsageRateCol || usageType == 2" mat-header-cell
                                *matHeaderCellDef mat-sort-header="avg_usage_rate" class="space th-title">
                                {{ 'LIVE_INFO.AVG_RATE' | translate }}
                            </th>
                            <td [hidden]="!binAvgUsageRateCol || usageType == 2" class="space td-value" mat-cell *matCellDef="let element"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                {{element?.avg_usage_rate != -1 ? element?.avg_usage_rate + '%': ''}}</td>
                        </ng-container>
    
                        <ng-container matColumnDef="collection_frequency">
                            <th [hidden]="!binCollectionFrequencyCol || usageType == 2" mat-header-cell *matHeaderCellDef 
                            mat-sort-header="collection_frequency" class="space th-title">
                            {{'MANAGE_BIN.MONTHLY_COLLECTION_FREQ' | translate }}
                            </th>
                            <td [hidden]="!binCollectionFrequencyCol || usageType == 2" class="space td-value" mat-cell *matCellDef="let element"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                {{element?.collection_frequency != -1 ? element?.collection_frequency : ''}}
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="emptying_dunam">
                            <th [hidden]="usageType == 1 || !avgDailyRateDunamCol" mat-header-cell
                                *matHeaderCellDef mat-sort-header="emptying_dunam" class="space th-title">
                                {{'LIVE_INFO.AVG_DAILY_EMPTYING_RATE_DUNAM' | translate }} </th>
                            <td [hidden]="usageType == 1 || !avgDailyRateDunamCol" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                @if (currentLang == 'iw') {
                                    <span rtlDiv>
                                        {{element.emptying_dunam}} 
                                        @if (element.emptying_dunam != null) {
                                            <span>ל/ד</span>
                                        } 
                                    </span>
                                }
                                @if (currentLang != 'iw') {
                                    <span rtlDiv>
                                        {{element.emptying_dunam}} 
                                        @if (element.emptying_dunam != null){
                                            <span>L/D</span>
                                        }
                                    </span>
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="predicted_time_for_max_allowed_capacity">
                            <th [hidden]="!binPredictedTimeForMaxAllowedCapacityCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="predicted_time_for_max_allowed_capacity_value" class="space th-title"> 
                                {{ 'LIST_COLUMNS.FULLNESS_FORECAST_DATE' | translate }} 
                            </th>
                            <td [hidden]="!binPredictedTimeForMaxAllowedCapacityCol" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                <span>{{element ? element.predicted_time_for_max_allowed_capacity : ''}}</span>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="black_status">
                            <th [hidden]="!binBlackStatusCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="over_flow_dates" class="space th-title">
                                {{'MANAGE_BIN.BLACK_STATUS' | translate }} </th>
                            <td [hidden]="!binBlackStatusCol" mat-cell *matCellDef="let element" class="space td-value"
                                [ngClass]="{'blur-txt': element.collection_mode == 1}">
                                @if (showLoadingForCurrentCapacityAnalysis) {
                                    <ng-lottie [options]="options"></ng-lottie>
                                }
                                @if (!showLoadingForCurrentCapacityAnalysis && element.over_flow_dates != 0){
                                    <span rtlDiv>{{element.over_flow_dates}}</span>
                                }
                                @if (!showLoadingForCurrentCapacityAnalysis && element.over_flow_dates >= element.analysis_time_span_in_days && element.over_flow_dates != 0) {
                                    <span>+</span>
                                }
                                @if (element.number_of_bins_in_cluster > 1 && !showLoadingForCurrentCapacityAnalysis && element.over_flow_dates != 0) {
                                    <span> ({{element.cluster_avg.toFixed(0)}}{{usageType == 1 ? '%' : 'L'}})</span>
                                }
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="collection_mode">
                            <th [hidden]="!binCollectionModeCol" mat-header-cell *matHeaderCellDef
                                mat-sort-header="collection_mode" class="space th-title"> 
                                {{'MANAGE_BIN.INCLUDE_IN_WORKPLAN' | translate }} 
                            </th>
                            <td [hidden]="!binCollectionModeCol" mat-cell *matCellDef="let element" class="space td-value">
                                <img class='search-input-img' title="{{element ? getTitle(element) : ''}}"
                                    src="{{element ? getImg(element.collection_mode) : ''}}" alt="" />
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="collection_days">
                            <th [hidden]="!binCollectionDaysCol" mat-header-cell *matHeaderCellDef mat-sort-header="active_collection_days" class="space th-title"> 
                                {{'MANAGE_BIN.BIN_COLLECTION_DAYS' | translate }} 
                            </th>
                            <td [hidden]="!binCollectionDaysCol" mat-cell *matCellDef="let element" class="space td-value">
                                @if (showLoadingForCollectionDays) {
                                    <ng-lottie [options]="options"></ng-lottie>
                                }
                                @if (!showLoadingForCollectionDays && element.collection_days) {
                                <div class="dflex-days">
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].sunday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].sunday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].sunday,'text-day-notSelected': !element.collection_days[0].sunday}">
                                            {{ 'NEW_WORKPLAN.SUNDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].monday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].monday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].monday,'text-day-notSelected': !element.collection_days[0].monday}">
                                            {{ 'NEW_WORKPLAN.MONDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].tuesday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].tuesday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].tuesday,'text-day-notSelected': !element.collection_days[0].tuesday}">
                                            {{ 'NEW_WORKPLAN.TUESDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].wednesday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].wednesday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].wednesday,'text-day-notSelected': !element.collection_days[0].wednesday}">
                                            {{ 'NEW_WORKPLAN.WEDNESDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].thursday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].thursday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].thursday,'text-day-notSelected': !element.collection_days[0].thursday}">
                                            {{ 'NEW_WORKPLAN.THURSDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].friday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].friday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].friday,'text-day-notSelected': !element.collection_days[0].friday}">
                                            {{ 'NEW_WORKPLAN.FRIDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                    <div class="grayCircle-container">
                                        @if (element.collection_days[0].saturday) {
                                            <img src="assets/images/inventory/grayCircle.svg" alt="" />
                                        }
                                        @if (!element.collection_days[0].saturday) {
                                            <img src="assets/images/inventory/whiteCircle.svg" alt="" />
                                        }
                                        <div [ngClass]="{'text-day': element.collection_days[0].saturday,'text-day-notSelected': !element.collection_days[0].saturday}">
                                            {{ 'NEW_WORKPLAN.SATURDAY_COLLECTION' | translate }}
                                        </div>
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <app-pagination [chosenBins]="filteredBinsData" (pageChange)='onPageChange($event)' [filesPerPage]="8"></app-pagination>
                </div>
                <div class="add-col">
                    <img (click)="showDropDown()" class="enableBtn" rtlDiv id="dropdownMenuButton-modal"
                        data-bs-toggle="dropdown" src="assets/images/dashboard/addCol.svg" alt="" />
                    <div class="dropdown-menu list-items" rtlDiv aria-labelledby="dropdownMenuButton-modal">
                        <div class="inner-dropdown">
                            @if (usageType == 1) {
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isNeighborhoodChecked" [checked]="neighborhood"
                                    (change)="toggleEditable(isNeighborhoodChecked)" type="checkbox"
                                    id="scalesNeighborhood-modal" name="scalesNeighborhood-modal">
                                <label for="scalesNeighborhood-modal" class="txt">{{
                                    'LIST_COLUMNS.NEIGHBORHOOD' | translate }}</label>
                            </div>
                            }
                            <div class="flexOnly" rtlDiv [hidden]="usageType == 1">
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinNameColChecked"
                                    [checked]="binNameCol" (change)="toggleEditableName(isBinNameColChecked)" type="checkbox"
                                    id="scalesName-modal" name="scalesName-modal">
                                <label for="scalesName-modal" class="txt">
                                    {{ 'LIST_COLUMNS.NAME' | translate }}
                                </label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinSiteColChecked" [checked]="binSiteCol"
                                    (change)="toggleEditableSite(isBinSiteColChecked)" type="checkbox"
                                    id="scalesSite-modal" name="scalesSite-modal">
                                <label for="scalesSite-modal" class="txt">
                                    {{ 'TRUCK_MAP.SITE' | translate }}
                                </label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinIdColChecked"
                                    [checked]="binIdCol" (change)="toggleEditableId(isBinIdColChecked)"
                                    type="checkbox" id="scalesId-modal" name="scalesId-modal">
                                <label for="scalesId-modal" class="txt">{{ 'LIST_COLUMNS.ID' | translate
                                    }}</label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinTypeColChecked" [checked]="binTypeCol"
                                    (change)="toggleEditableType(isBinTypeColChecked)" type="checkbox"
                                    id="scalesType-modal" name="scalesType-modal">
                                @if (usageType == 1) {
                                <label for="scalesType-modal" class="txt">{{ 'LIST_COLUMNS.BIN_TYPE' |
                                    translate }}</label>
                                }
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinInstallDateColChecked" [checked]="binInstallDateCol"
                                    (change)="toggleEditableInstallation(isBinInstallDateColChecked)"
                                    type="checkbox" id="scalesInstallation-modal" name="scalesInstallation-modal">
                                <label for="scalesInstallation-modal" class="txt">{{
                                    'LIST_COLUMNS.INSTALLATION_DATE' | translate }}</label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinAvgRateColChecked" [checked]="binAvgRateCol"
                                    (change)="toggleEditableAvgRate(isBinAvgRateColChecked)"
                                    type="checkbox" id="scalesAvgRate-modal" name="scalesAvgRate-modal">
                                @if (usageType == 1) {
                                <label for="scalesAvgRate-modal" class="txt">{{ 'LIVE_INFO.EMPTY_RATE' | translate }}</label>
                                }
                            </div>
                            @if (usageType == 1) {
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinAvgUsageRateChecked" [checked]="binAvgUsageRateCol"
                                    (change)="toggleEditableAvgUsageRate(isBinAvgUsageRateChecked)"
                                    type="checkbox" id="scalesAvgUsageRate-modal" name="scalesAvgUsageRate-modal">
                                <label for="scalesAvgUsageRate-modal" class="txt">{{ 'LIVE_INFO.AVG_RATE' |
                                    translate }}</label>
                            </div>
                            }
                            @if (usageType == 1) {
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv
                                    [(ngModel)]="isBinCollectionFrequencyChecked" [checked]="binCollectionFrequencyCol"
                                    (change)="toggleEditableCollectionFrequency(isBinCollectionFrequencyChecked)"
                                    type="checkbox" id="scalesCollectionFrequency-modal" name="scalesCollectionFrequency-modal">
                                <label for="scalesCollectionFrequency-modal" class="txt">{{
                                    'MANAGE_BIN.MONTHLY_COLLECTION_FREQ' | translate }}</label>
                            </div>
                            }
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv
                                    [(ngModel)]="isBinPredictedTimeForMaxAllowedCapacityChecked"
                                    [checked]="binPredictedTimeForMaxAllowedCapacityCol"
                                    (change)="toggleEditablePredictedTimeForMaxAllowedCapacity(isBinPredictedTimeForMaxAllowedCapacityChecked)"
                                    type="checkbox" id="scalesPredictedTimeForMaxAllowedCapacity-modal"
                                    name="scalesPredictedTimeForMaxAllowedCapacity-modal">
                                <label for="scalesPredictedTimeForMaxAllowedCapacity-modal" class="txt">
                                    {{'LIST_COLUMNS.FULLNESS_FORECAST_DATE' | translate }}
                                </label>
                            </div>
                            <div class="flexOnly flex-gap" rtlDiv>
                                <div class="flex-black-status">
                                    <input class="inputChx" rtlDiv [(ngModel)]="isBlackStatusChecked"
                                        [checked]="binBlackStatusCol" (change)="toggleEditableBlackStatus(isBlackStatusChecked)"
                                        type="checkbox" id="scalesBlackStatus-modal" name="scalesBlackStatus-modal">
                                    <label rtlDiv for="scalesBlackStatus-modal" class="txt">
                                        {{'MANAGE_BIN.BLACK_STATUS' | translate }}
                                        ({{blackStatusValue}}%)
                                    </label>
                                </div>
                                <div rtlDiv>
                                    <form class="blackStatus" [formGroup]="ElForm" rtlDiv>
                                        @if (!editBlackStatusFlag) {
                                        <div class="balck-status-input-frame">
                                            <input min="90" max="100" class="black-status-input" type="number" matInput formControlName="blackStatusBin" rtlDiv>
                                            <img [ngClass]="{'noClick': ElForm.getRawValue()['blackStatusBin'] < 90 || ElForm.getRawValue()['blackStatusBin'] > 100,'enableBtn': ElForm.getRawValue()['blackStatusBin'] >= 90 && ElForm.getRawValue()['blackStatusBin'] <= 100}"
                                                (click)="submitBlackStatus()" src="assets/images/inventory/submit-V.svg" alt="" />
                                        </div>
                                        }
                                        @if (editBlackStatusFlag) {
                                            <div class="balck-status-edit-frame" (click)="editBlackStatus();$event.stopPropagation()">
                                                <div>{{ 'TITLES.EDIT' | translate }}</div>
                                            </div>
                                        }
                                    </form>
                                </div>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinCollectionModeChecked"
                                    [checked]="binCollectionModeCol"
                                    (change)="toggleEditableCollectionMode(isBinCollectionModeChecked)"
                                    type="checkbox" id="scalesCollectionMode-modal"
                                    name="scalesCollectionMode-modal">
                                <label for="scalesCollectionMode-modal" class="txt">{{ 'MANAGE_BIN.INCLUDE_IN_WORKPLAN'
                                    | translate }}</label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinCollectionDaysChecked"
                                    [checked]="binCollectionDaysCol"
                                    (change)="toggleEditableCollectionDays(isBinCollectionDaysChecked)"
                                    type="checkbox" id="scalesCollectionDays-modal"
                                    name="scalesCollectionDays-modal">
                                <label for="scalesCollectionDays-modal" class="txt">{{
                                    'MANAGE_BIN.BIN_COLLECTION_DAYS' | translate }}</label>
                            </div>
                            <div class="flexOnly" rtlDiv>
                                <input class="inputChx" rtlDiv [(ngModel)]="isBinDeviceIdColChecked"
                                    [checked]="binDeviceIdCol"
                                    (change)="toggleEditableDeviceId(isBinDeviceIdColChecked)"
                                    type="checkbox" id="scalesDeviceId-modal" name="scalesDeviceId-modal">
                                <label for="scalesDeviceId-modal" class="txt">
                                    {{ 'SITE_MANAGMENT.DEVICE_ID' | translate }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-container" rtlDiv>
                <div class="cancel-btn" (click)="closeModal()">
                    {{ 'MANAGE_BIN.CANCEL' | translate }}
                </div>
                <div class="apply-btn" [ngClass]="{'disable-compare-btn-container': selection.selected.length == 0}" (click)="applyChanges()">
                    {{'TITLES.APPLY_MORE_BINS' | translate}}
                </div>
            </div>
        </div>
    </div>
    }
    
    @if (isMobile) {
    
    }